import { defineStore } from "pinia";
import mushroom from "cem-primary-api";

export const profileUserStore = defineStore({
  id: "profileUser",
  state: () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    return {
      name: "",
      avatarLink: "",
      roles: userInfo?.result?.roles?.[0] || "",
      phone: "",
      email: "",
      department: "",
      group: [],
      accountType: "",
    };
  },
  actions: {
    async getProfileUser() {
      const responseUser = JSON.parse(localStorage.getItem("userInfo"));
      let id_currentUser = responseUser.result.id;
      try {
        const response = await mushroom.profile.listAsync({
          filters: ["id=" + id_currentUser],
        });
        this.name = response.result[0].fullname;
        this.roles = responseUser.result.roles[0];
        this.phone = response.result[0].phoneNumber
          ? response.result[0].phoneNumber
          : "";
        this.email = response.result[0].email ? response.result[0].email : "";
        this.accountType = response.result[0].account_type || "";
        if (response.result[0].avatarId) {
          this.avatarLink = mushroom.$file.linkBuilder.thumb
            .id(response.result[0].avatarId)
            .build();
        }

        if (response.result[0].department_id) {
          try {
            const res = await mushroom.department.findByIdAsync({
              id: response.result[0].department_id,
            });
            if (res.result) this.department = res.result.name;
          } catch (e) {
            console.error("Có lỗi: %o", e);
          }
        }
        let filtersUserGroup = "";
        if (
          responseUser.result.roles.includes("Admin") ||
          responseUser.result.roles.includes("AdminLocal") ||
          responseUser.result.roles.includes("AdminPrimary")
        ) {
          filtersUserGroup = ["user_id=" + id_currentUser];
        }
        const responseDepartment = await mushroom.user_group.getAllAsync({
          filters: filtersUserGroup,
        });

        this.group = [];
        responseDepartment.result?.forEach(async (item) => {
          const response = await mushroom.group.findByIdAsync({
            id: item.group_id, // required
          });
          if (response.result) this.group.push(response.result.name);
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
  },
  getters: {
    getRoles: (state) => {
      return state;
    },
  },
});
